<template>
  <div :data-theme="props.domain ?? undefined">
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { Domain } from '@gro-up/types'
import { provide, toRef } from 'vue'

// 'none-existing-domain' is used for the error page to avoid applying any domain styles
type Props = {
  domain?: Domain | null | 'none-existing-domain'
}

const props = withDefaults(defineProps<Props>(), {
  domain: null,
})

// Provide the (reactive) domain to children via inject/provide pattern.
const domain = toRef(() => (props.domain === 'none-existing-domain' ? null : props.domain))
provide('domain', domain)
</script>
